module.exports = __webpack_public_path__ + "assets1783936157458/img/error-500.a371eabc.svg";